<template>
  <modal
    title="Apply promo code"
    :open="open"
    @close="$emit('close')"
  >
    <form @submit.prevent="submit">
      <text-input
        id="promo"
        v-model.trim="promoInput"
        type="text"
        label="Promo code"
      />

      <btn type="submit">
        Apply
      </btn>
    </form>
  </modal>
</template>

<script>
export default {
  props: {
    open: Boolean,
  },

  data() {
    return {
      promoInput: '',
    };
  },

  methods: {
    submit() {
      this.$emit('submit', this.promoInput);
      this.promoInput = '';
      this.$emit('close');
    },
  },
};
</script>
